import { GlobalAppState } from '@model/state';

export const getModalType = (state: GlobalAppState) => state.app.modal.modalType;
export const getModalData = (state: GlobalAppState) => state.app.modal.modalData;
export const getHasClosedViewRoomTypesModal = (state: GlobalAppState) =>
  state.app.modal.modalHistory.hasClosedViewRoomTypesModal;
